<div class="failedSearch" *ngIf="loadFailed">
    <div class="forge-typography--heading2">{{loadFailedMessage}}</div>
</div>
<forge-card class="info-grid--container no-padding" [ngClass]="{'combined-view-grid': combinedViewTable}">
    <igx-grid igxPreventDocumentScroll #grid [isLoading]="fetching || isAdding || grouping" [id]="providerId" [data]="data | async"
              [primaryKey]="'Id'" [igxGridState]="options" [rowSelection]="selectionMode" emptyFilteredGridMessage="No records found. They may be hidden by grid filters."
              (activeNodeChange)="activeNodeChange($event)" [hideRowSelectors]="hideRowSelectors"
              (columnInit)="onColumnInit($event)" (cellEditEnter)="onCellEditEnter($event)"
              (cellEditExit)="endCellEdit($event)" (keyup)="onKeyUp($event)" (gridKeydown)="handleGridKeydown($event)"
              (rowSelectionChanging)="onRowSelect($event)" [cellSelection]="cellSelectionMode"
              (keydown)="onKeyDown($event)" [allowFiltering]="ColumnFiltering" [filterMode]="'excelStyleFilter'"
              [moving]="true" [pagingMode]="mode" [filterStrategy]="filterStrategy" [sortStrategy]="sortStrategy"
              [clipboardOptions]="clipboardOptions" [uniqueColumnValuesStrategy]="columnValuesStrategy"
              (doubleClick)="editRow($event)" (contextMenu)="onContextMenu($event)" height="100%" (columnPinned)="columnPinned($event)"
              (selected)="onCellSelect($event)" [ngClass]="{'alternate-grid-lines': alternateGridLines}" (gridScroll)="onScroll($event)">
        <ng-template igxRowSelector let-rowContext>
            <div class="row-selector">
                <igx-checkbox [readonly]="true" [checked]="rowContext.selected" (click)="rowCheckSelect()"
                              [disabled]="!isSelectionAllowed(rowContext.rowID)"
                              [aria-label]="rowContext.selected ? 'Deselect row ' + rowContext.index + 1 : 'Select row ' + rowContext.index + 1">
                </igx-checkbox>
            </div>
        </ng-template>
        <igx-column *ngIf="showIdTemplate()" field="Id" header="Id" [hidden]="true" [disableHiding]="true"
                    [disablePinning]="true" [filterable]="false"></igx-column>
        <igx-column *ngFor="let column of columns; trackBy: trackByFn" [field]="column.Name" [groupable]="isGroupedGrid"
                    [width]="getColumnWidth(column.Name)" [header]="column.Label" [dataType]="getColumnDataType(column)"
                    editable="true" [resizable]="true" [sortable]="allowSort && !column.IsIcon"
                    [filterable]="column.IsFilterable" [hasSummary]="hasSummary(column.Name)"
                    [summaries]="useSummary(column.IsCurrency, column.Name)"
                    [hidden]="columnHidden(column.Name) || column.AlwaysHidden" [disableHiding]="column.AlwaysHidden"
                    [disablePinning]="!pinnable(column)" [cellClasses]="cellClasses">

            <ng-template igxHeader let-column>
                <column-move-selector [grid]="grid" [column]="column" [columns]="columns" title="{{column.header}}"></column-move-selector>
            </ng-template>

            <ng-template *ngIf="column.IsBoolean" igxCell let-cell="cell" let-val #booleanTemplate>
                <div style="width: 100%; text-align: center;" (click)="editCheckbox(cell)">
                    <forge-icon *ngIf="parseBooleanValue(val)" name="check_box" class="grid-icon" aria-label="checked"></forge-icon>
                    <forge-icon *ngIf="!parseBooleanValue(val)" name="check_box_outline_blank" class="grid-icon" aria-label="not checked">
                    </forge-icon>
                </div>
            </ng-template>
            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && noFormatAction(column)"
                         igxCell let-cell="cell" let-val #actionTemplate>
                <div [attr.role]="cellActionClass(column, cell) ? 'link' : undefined" [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)">
                    <span class="igx-grid-cell-value">{{val}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.IsCurrency"
                         igxCell let-cell="cell" let-val #actionCurrencyTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | gridCurrency: column}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && (column.DataType === 'number' || column.DataType === 'nonDelineatedNumber') && !column.IsCurrency"
                         igxCell let-cell="cell" let-val #actionNumberTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | gridNumber: column:false}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.DataType === 'percent'"
                         igxCell let-cell="cell" let-val #actionPercentTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | gridNumber: column:true}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.DataType === 'date'"
                         igxCell let-cell="cell" let-val #actionDateTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | date:'MM/dd/yyyy'}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.DataType === 'dateTime'"
                         igxCell let-cell="cell" let-val #actionDateTimeTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | date: dateTimeFormat}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.DataType === 'time'"
                         igxCell let-cell="cell" let-val #actionTimeTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | date: timeFormat}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="(column.IsLinkAction || column.IsMetadataAction) && !column.IsIcon && column.DataType === 'time24'"
                         igxCell let-cell="cell" let-val #actionTimeTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="link">
                    <span class="igx-grid-cell-value">{{val | date: timeFormat24}}</span>
                </div>
            </ng-template>

            <ng-template *ngIf="column.IsIcon" igxCell let-cell="cell" let-val #iconTemplate>
                <div [ngClass]="{'cell-action': cellActionClass(column, cell), 'cell-action-disabled': isDisabled(cell)}" (click)="doAction(cell)" role="button">
                    <forge-icon [name]="getIcon(cell)" [hidden]="useIconSpan(cell) || isHidden(cell)">
                        <forge-tooltip>{{val}}</forge-tooltip>
                    </forge-icon>
                    <span class="tt-icon {{getIcon(cell)}}" [hidden]="!useIconSpan(cell) || isHidden(cell)"></span>
                </div>
            </ng-template>
            <ng-template *ngIf="column.IsCurrency" igxCell let-cell="cell" let-val #currencyTemplate>
                <span class="igx-grid-cell-value">{{val | gridCurrency: column}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'number' || column.DataType === 'nonDelineatedNumber'" igxCell let-cell="cell" let-val #numberTemplate>
                <span class="igx-grid-cell-value">{{val | gridNumber: column:false}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'percent'" igxCell let-cell="cell" let-val #percentTemplate>
                <span class="igx-grid-cell-value">{{val | gridNumber: column:true}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'date'" igxCell let-cell="cell" let-val #dateTemplate>
                <span class="igx-grid-cell-value">{{val | date:'MM/dd/yyyy'}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'dateTime'" igxCell let-cell="cell" let-val #dateTimeTemplate>
                <span class="igx-grid-cell-value">{{val | date: timeFormat(column.Name, true)}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'time'" igxCell let-cell="cell" let-val #timeTemplate>
                <span class="igx-grid-cell-value">{{val | date: timeFormat(column.Name)}}</span>
            </ng-template>
            <ng-template *ngIf="column.DataType === 'time24'" igxCell let-cell="cell" let-val #timeTemplate>
                <span class="igx-grid-cell-value">{{val | date: timeFormat24(column.Name)}}</span>
            </ng-template>
            <ng-template *ngIf="!!column.DocumentLookupType" let-val igxCell let-cell="cell" #docLookupTemplate>
                <forge-circular-progress *ngIf="showSpinner(column)" class="metadata-input--spinner">
                </forge-circular-progress>
                <span *ngIf="!showSpinner(column)" class="igx-grid-cell-value">{{val}}</span>
            </ng-template>

            <ng-template igxCellEditor let-cell="cell" let-value #cellEditTemplate>
                <div #cellEditInput fxFill>
                    <form>
                        <metadata-input ngModelGroup="cellEditGrp_{{cell.column.field}}" *ngIf="!cellEditTransition"
                                        fxFill [field]="cell.column.field" id="{{cell.column.field}}_gridInput"
                                        [metadata]="cellEditMetadata" [metadataModel]="cellEditModel"
                                        [parent]="cellEditModelParent" [datacontroller]="datacontroller"
                                        [parentGridProvider]="providerId" [forCellEdit]="true" [dense]="true"
                                        (keydown)="cellEditKeyDown($event)">
                        </metadata-input>
                    </form>
                </div>
            </ng-template>
        </igx-column>

        <ng-template igxExcelStyleHeaderIcon>
            <forge-icon class="grid-filter-icon" name="filter_alt"></forge-icon>
        </ng-template>

        <igx-grid-excel-style-filtering [minHeight]="filterHeight" [maxHeight]="filterHeight">
            <igx-excel-style-column-operations>
                <igx-excel-style-header [showPinning]="true" [showHiding]="true"></igx-excel-style-header>
            </igx-excel-style-column-operations>
            <igx-excel-style-filter-operations>
                <igx-excel-style-clear-filters (click)="clearCustomFilter()"></igx-excel-style-clear-filters>
                <igx-excel-style-conditional-filter></igx-excel-style-conditional-filter>
                <grid-filter *ngIf="showCustomFilter" [grid]="grid" [columns]="columns" [viewMetadata]="viewMetadata"></grid-filter>
                <igx-excel-style-search *ngIf="showExcelStyleSearch" style="max-height:280px;"></igx-excel-style-search>
            </igx-excel-style-filter-operations>
        </igx-grid-excel-style-filtering>

        <igx-action-strip #actionStrip>
            <row-actions *ngIf="!cellEditing" [actionStrip]="actionStrip" [providerId]="providerId"
                         [cellEdit]="isGridCellEdit" [useRepository]="useRepository" [(refreshAction)]="refreshAction"
                         [disableViewAction]="disableViewAction" [datacontroller]="datacontroller"
                         (repositoryFunction)="doRepositoryFunction($event.command, $event.row)"
                         [multipleEdit]="multipleEdit" [viewMetadata]="viewMetadata">
            </row-actions>
        </igx-action-strip>
        <igx-grid-toolbar #toolbar>
            <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <h2 *ngIf="showTitle" class="forge-typography--heading2">
                        {{viewMetadata.Title}}
                    </h2>
                    <h1 *ngIf="showH1Title" class="forge-typography--heading2">
                        {{h1Title}}
                    </h1>
                    <forge-badge *ngIf="showFiltered" theme="info-secondary" class="tt-margin--left">Filtered</forge-badge>
                </div>
                <span fxFlex="auto"></span>
                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="AllowMultipleDelete">
                    <forge-button (click)="deleteMultipleRows()">
                        <forge-icon name="delete" style="color: var(--forge-theme-primary);"></forge-icon>
                        <span style="color: var(--forge-theme-primary);">Delete selected</span>
                    </forge-button>
                </div>
                <span fxFlex="auto"></span>
                <div fxLayout="row" fxLayoutAlign="end center" style="position: sticky; right: 16px;">
                    <forge-icon-button (click)="tableOptionsOpen = !tableOptionsOpen" aria-label="Toggle table options"
                                       class="grid-icon-button">
                        <forge-tooltip placement="bottom">
                            <span>{{ tableOptionsOpen ? 'Hide' : 'Show' }} table options</span>
                        </forge-tooltip>
                        <forge-open-icon [open]="!tableOptionsOpen" orientation="horizontal"></forge-open-icon>
                        <forge-focus-indicator circular inward></forge-focus-indicator>
                    </forge-icon-button>

                    <forge-expansion-panel orientation="horizontal" [open]="tableOptionsOpen" aria-label="Table options"
                                           role="region">
                        <div *ngIf="showToolbar && grid.toolbar" fxLayout="row" fxLayoutAlign="end center"
                             class="table-options toolbar-icon-container">

                            <forge-icon-button [hidden]="!showFiltered" class="button grid-icon-button"
                                               (click)="clearFilter()" aria-label="clear filters">
                                <forge-tooltip placement="bottom">Clear filters</forge-tooltip>
                                <forge-icon name="filter_remove"></forge-icon>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>

                            <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                            <forge-icon-button (click)="openColumnVisibility()" class="button grid-icon-button"
                                               aria-label="Column visibility" telemetry="Load-Column-visibility"
                                               [variant]="toolbarButtonVariant('visibility')">
                                <forge-icon name="eye"></forge-icon>
                                <forge-tooltip placement="bottom">Column visibility</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>

                            <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                            <forge-icon-button (click)="openColumnPinning()" class="button grid-icon-button"
                                               aria-label="Column pinning" telemetry="Load-Column-pinning"
                                               [variant]="toolbarButtonVariant('pinning')">
                                <forge-icon name="pin"></forge-icon>
                                <forge-tooltip placement="bottom">Column pinning</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>

                            <forge-icon-button [igxToggleAction]="exportDropdown"
                                               [igxDropDownItemNavigation]="exportDropdown"
                                               class="button grid-icon-button"
                                               aria-label="Export" telemetry="Load-Export">
                                <forge-icon name="file_upload"></forge-icon>
                                <forge-tooltip placement="bottom">Export</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>

                            <igx-drop-down #exportDropdown>
                                <div class="dropdown-item-container">
                                    <igx-drop-down-item (click)="exportData('excel')" igxRipple value="excel" role="option" index="0">
                                        <span>Export to Excel</span>
                                    </igx-drop-down-item>
                                    <igx-drop-down-item *ngIf="allowCsvExport" (click)="exportData('csv')" igxRipple value="csv" role="option" index="1">
                                        <span>Export to CSV</span>
                                    </igx-drop-down-item>
                                </div>
                            </igx-drop-down>

                            <forge-icon-button *ngIf="allowShowRecent" (click)="toggleHistory(!recentLoaded)"
                                               class="button grid-icon-button" telemetry="Load-Recent"
                                               [variant]="toolbarButtonVariant('history')"
                                               aria-label="Recent grid history">
                                <forge-icon name="history"></forge-icon>
                                <forge-tooltip placement="bottom">Recent history</forge-tooltip>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>

                            <forge-icon-button [hidden]="!enableLayout" class="button grid-icon-button"
                                               [igxToggleAction]="gridLayoutDropdown"
                                               [igxDropDownItemNavigation]="gridLayoutDropdown"
                                               aria-label="Layout options">
                                <forge-tooltip placement="bottom">Layout options</forge-tooltip>
                                <forge-icon name="grid_view"></forge-icon>
                                <forge-focus-indicator circular inward></forge-focus-indicator>
                            </forge-icon-button>
                            <igx-drop-down #gridLayoutDropdown>
                                <div class="dropdown-item-container">
                                    <igx-drop-down-item (click)="layoutAction($event)" igxRipple
                                                        *igxFor="let item of layoutOptions; index as index;"
                                                        [value]="item.value" role="option" [index]="index">
                                        <span>{{ item.label }}</span>
                                    </igx-drop-down-item>
                                </div>
                            </igx-drop-down>
                        </div>
                    </forge-expansion-panel>

                    <forge-button *ngIf="canAdd" variant="raised" aria-label="Add" [disabled]="isViewOnly() || isAdding || disableGridAdd"
                                  (click)="addItem(true)" tabindex="0" dense>
                        <forge-icon slot="start" name="add"></forge-icon>
                        Add
                    </forge-button>

                    <command-menu *ngIf="commandMenu" [commands]="commands" icon="more_vert" always-show-icon="true"
                                  fxLayout="row" fxLayoutAlign="space-between center" position="target-right bottom"
                                  telemetry="Menu-Table">
                    </command-menu>

                    <command-bar *ngIf="commandBar" [commands]="commands" fxLayout="row"
                                 fxLayoutAlign="space-between center" telemetry="Menu-TableMenuBar">
                    </command-bar>
                </div>
            </div>
        </igx-grid-toolbar>

        <igx-paginator *ngIf="!hidePaginator">
            <igx-paginator-content fxLayoutAlign="end">
                <div *ngIf="infiniteScroll">Total Records: {{totalCount}}</div>
                <forge-paginator *ngIf="!infiniteScroll" (forge-paginator-change)="paginate($event.detail)" [total]="totalCount"
                                 [pageSize]="perPage" [ngClass]="{'space-for-fab': spaceForFab}" [pageIndex]="page"
                                 [pageSizeOptions]="selectOptions" style="position: sticky; right: 24px;" first-last>
                </forge-paginator>
            </igx-paginator-content>
        </igx-paginator>
    </igx-grid>
</forge-card>

